import colors from "../../../../utils/colors";

/** Detections: increase is bad (red), decrease is good (green). */
export function detectionPercentColor(percent) {
  if (percent === null || percent === undefined) return colors.red[100];
  if (percent > 0) return colors.red[100];
  if (percent < 0) return "#1DD75B";
  return colors.neutral[600];
}

export function isDetectionTrendUp(percent) {
  if (percent === null || percent === undefined) return true;
  return percent > 0;
}

/** Traffic / requests: increase shown as green, decrease as red. */
export function performancePercentColor(percent) {
  if (percent === null || percent === undefined) return colors.neutral[600];
  if (percent > 0) return "#1DD75B";
  if (percent < 0) return colors.red[100];
  return colors.neutral[600];
}

export function isPerformanceTrendUp(percent) {
  if (percent === null || percent === undefined) return false;
  return percent > 0;
}
